import React from 'react'

function VideoCard({info}) {
    
    const {snippet,statistics}=info;
    const {thumbnails}=snippet;
    
  return (
    <div className='p-2 h-full m-2 w-80 hover:scale-110  '>
    
    <img className='rounded-lg h-1/2 '
     alt="thumbnail" 
     src={thumbnails.medium.url}  />
    <ul className='h-1/2 p-2 m-2'>
    <li className=' font-semibold  text-sm py-2  truncate '>{snippet.title}</li>
    <li className='font-semibold  text-gray-600'>{snippet.channelTitle}</li>
    <li className='font-semibold text-gray-600'>{(statistics.likeCount/10000).toFixed(1)}K👍</li>
    <li className='text-gray-500'>{(statistics.viewCount/1000000).toFixed(2)}K 👀</li>
    
    </ul>
    
    </div>
  )
}


export default VideoCard